module.exports = __webpack_public_path__ + "img/bespoke123_19.72d0fee5.jpg";